export default "__VITE_ASSET__DNnAAfCq__"